module.exports = __webpack_public_path__ + "img/4885c677d7dee76b7961b68adc181892.dd1dbc01.png";